import { CreateEscortComponent } from './create-escort/create-escort.component';
import { EditEscortComponent } from './edit-escort/edit-escort.component';
import { SingleViewEscortComponent } from './view-escort/single-view-escort.component';
import { ViewEscortComponent } from './view-escort/viewescort.component';

export const EscortDetailsRouting = [
    { path: '', redirectTo: 'view-escort', pathMatch: 'full' },
    { path: 'add-escort', component: CreateEscortComponent },
    { path: 'view-escort', component: ViewEscortComponent },
    { path: 'single-view-escort/:escortID', component: SingleViewEscortComponent },
    { path: 'edit-escort/:escortID', component: EditEscortComponent },
];

export const EscortDetailsRoutingBreadcrumbs = [
    { name: 'Single-view',path:'/single-view-escort' },
    { name: 'Edit', path: '/edit-escort' },
    { name: 'Add', path: '/add-escort' },

];